import React, { useEffect, useState } from "react";

//*MUI
import Datagrid from "../../../Subcomponents/Datagrid";
import { Box, Divider } from "@mui/material";
//*Redux
import { useSelector } from "react-redux";

//*files
import cssClasses from "./IndividualAllotmentDetails.module.css";
import {
  FetchIndividualUserFromServer,
  getLeadByUser,
} from "../../../Services/Dashboard";
import _, { uniqBy } from "lodash";
import { getProjectByTeamWise } from "../../../Services/AssignProject";
import { useNavigate } from "react-router-dom";
import EmptyState from "../../../Assets/Images/Common/noProjectFound.svg";
import { dismissLoader, presentLoader } from "../../../Services/loader";
import MultiSelectDropDown from "../../../Subcomponents/MultiSelectDropDown/MultiSelectDropDown";
import LeadStatusChip from "../../../Subcomponents/LeadStatusChip";
import Dot from "../../Icons/Dot";
import DateComponent from "../../../Subcomponents/DateComponent";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import SiteVisitDetailModal from "./SiteVisitDetailModal";
import CustomAutoComplete from "../../../Subcomponents/CustomAutoComplete";

function IndividualAllotmentDetails() {
  let loggedInUser = {};
  loggedInUser = useSelector((state) => state.Auth.user);
  const individualUserId = loggedInUser?.userId;
  const navigate = useNavigate();
  const [drpDownSelectedVal, setDrpDownSelectedVal] = useState("");
  const [pageNumber, setPageNumber] = useState(0);
  const [AllotmentRows, setAllotmentRows] = useState([]);
  const [pageSize, setPageSize] = useState(11);
  const [projectList, setProjectList] = useState([]);
  const [selectedProject, setSelectedProject] = useState([]);
  const [helperText, setHelperText] = useState({
    startDate: "",
    endDate: "",
  });
  const [selectDates, setSelectDates] = useState([
    {
      label: "StartDate",
      value: Number(window.location.search.split("?")[2].split("=")[1]),
    },
    {
      label: "EndDate",
      value: Number(window.location.search.split("?")[3].split("=")[1]),
    },
  ]);
  const [showSiteVisitModal, setShowSiteVisitModal] = useState(false);
  const [selectedSiteVisit, setSelectedSiteVisit] = useState([]);
  const [leadsList, setLeadsList] = useState([]);

  useEffect(() => {
    const arr = [];
    const leads_arr = [];
    const fetchLeads = async () => {
      const leadsArr = await getLeadByUser(individualUserId);

      leadsArr.data.forEach((s) => {
        leads_arr.push({
          name: s?.personId?.name,
          id: s?.personId?.personId,
        });
      });
    };
    const fetchProjects = async () => {
      const projectArr = await getProjectByTeamWise([individualUserId]);
      uniqBy(projectArr.data, "projectId.projectId").forEach((v) => {
        arr.push({
          name: v?.projectId?.projectName,
          id: v?.projectId?.projectId,
        });
      });
      const url_arr1 = window.location.search
        .split("?")[1]
        .split("=")[1]
        .split(",")
        .forEach((em) => {
          const url_val = arr.find((f) => f.name === decodeURIComponent(em));
          if (url_val !== undefined) {
            selectedProject.push(url_val);
          }
        });
      const sales_url = window.location.search.includes("leadName")
        ? decodeURIComponent(window.location.search.split("?")[4].split("=")[1])
        : "All";
      const final_url = leads_arr.find((f) => f.name === sales_url);
      setDrpDownSelectedVal(final_url === undefined ? "All" : final_url.name);

      UsersFromServer(
        0,
        false,
        individualUserId,
        selectedProject.map((m) => {
          return m.id;
        }),
        final_url ? final_url.id : null,
        selectDates
      );
      setProjectList(arr);
      setLeadsList(leads_arr);
    };
    fetchProjects();
    fetchLeads();
  }, []);

  const SoldDetailsColumns = [
    {
      field: "leadName",
      headerName: "Lead Name",
      width: 250,
      renderCell: (params) => {
        return (
          <div style={{ wordBreak: "break-word" }}>{params.row?.leadName}</div>
        );
      },
    },
    {
      field: "leadId",
      headerName: "Lead Id",
      width: 250,
      renderCell: (params) => {
        return (
          <div style={{ wordBreak: "break-word" }}> VJ
          {params?.row?.leadDisplayID
            ? params?.row?.leadDisplayID?.replace(
                params?.row?.leadDisplayID?.substring(8, 12),
                '-' + params?.row?.leadDisplayID?.substring(8, 12)
              )
            : '-'}
          </div>
        );
      },
    },
    {
      field: "projectName",
      headerName: "Project Name",
      width: 300,
      renderCell: (params) => {
        return (
          <div style={{ wordBreak: "break-word" }}>
            {params.row?.projectName}
          </div>
        );
      },
    },
    {
      field: "wingName",
      headerName: "Wing",
      width: 120,
      renderCell: (params) => {
        return (
          <div style={{ wordBreak: "break-word" }}>{params.row?.wingName}</div>
        );
      },
    },
    {
      field: "unitNo",
      headerName: "Unit",
      width: 120,
      renderCell: (params) => {
        return (
          <div style={{ wordBreak: "break-word" }}>{params.row?.unitNo}</div>
        );
      },
    },
    {
      field: "siteVisit",
      headerName: "Site Visit",
      width: 120,
      renderCell: (params) => {
        return (
          <div
            style={{
              wordBreak: "break-word",
              display: "flex",
              alignItems: "center",
              gap: "0.5rem",
            }}
          >
            {params.row?.siteVisit?.length}
            <InfoOutlinedIcon
              style={{ marginLeft: "4px", cursor: "pointer" }}
              onClick={() => {
                if(params.row?.siteVisit?.length > 0){
                setShowSiteVisitModal(true);
                setSelectedSiteVisit(params?.row?.siteVisit);
                }
              }}
            />
          </div>
        );
      },
    },
    {
      field: "status",
      headerName: "Status",
      width: 220,
      renderCell: (params) => {
        return (
          <div style={{ wordBreak: "break-word" }}>
            <div className={cssClasses.tokenStatus}>
              {params?.row?.status === "On Hold" && (
                <LeadStatusChip
                  label={params?.row?.status}
                  icon={<Dot width={"0.5rem"} height={"0.5rem"} />}
                  style={{
                    color: "rgb(89, 37, 220)",
                    backgroundColor: "rgb(244, 243, 255)",
                  }}
                ></LeadStatusChip>
              )}
              {params?.row?.status === "Agreement Done" && (
                <LeadStatusChip
                  label={params?.row?.status}
                  icon={<Dot width={"0.5rem"} height={"0.5rem"} />}
                  style={{
                    color: "#1570EF",
                    backgroundColor: "#EFF8FF",
                  }}
                ></LeadStatusChip>
              )}
              {(params?.row?.status === "Released" ||
                params?.row?.status.includes("Refund")) && (
                <LeadStatusChip
                  label={params?.row?.status}
                  icon={<Dot width={"0.5rem"} height={"0.5rem"} />}
                  style={{
                    color: "rgb(180, 35, 24)",
                    backgroundColor: "rgb(254, 243, 242)",
                  }}
                ></LeadStatusChip>
              )}
              {params?.row?.status.toLowerCase().includes("cancel") && (
                <LeadStatusChip
                  label={params?.row?.status}
                  icon={<Dot width={"0.5rem"} height={"0.5rem"} />}
                  style={{
                    color: "rgb(180, 35, 24)",
                    backgroundColor: "rgb(254, 243, 242)",
                  }}
                ></LeadStatusChip>
              )}
              {params?.row?.status === "Partial Payment Done" && (
                <LeadStatusChip
                  label={params?.row?.status}
                  icon={<Dot width={"0.5rem"} height={"0.5rem"} />}
                  style={{ color: "#B54708", backgroundColor: "#FFFAEB" }}
                ></LeadStatusChip>
              )}
              {params?.row?.status === "Payment Complete" && (
                <LeadStatusChip
                  label={params?.row?.status}
                  icon={<Dot width={"0.5rem"} height={"0.5rem"} />}
                  style={{ color: "#027A48", backgroundColor: "#ECFDF3" }}
                ></LeadStatusChip>
              )}
              {params?.row?.status === "Preselected" && (
                <LeadStatusChip
                  label={params?.row?.status}
                  icon={<Dot width={"0.5rem"} height={"0.5rem"} />}
                  style={{ color: "#027A48", backgroundColor: "#ECFDF3" }}
                ></LeadStatusChip>
              )}
              {params?.row?.status === "Payment Pending" && (
                <LeadStatusChip
                  label={params?.row?.status}
                  icon={<Dot width={"0.5rem"} height={"0.5rem"} />}
                  style={{ color: "#B42318", backgroundColor: "#FEF3F2" }}
                ></LeadStatusChip>
              )}
              {params?.row?.status === "Change Requested" && (
                <LeadStatusChip
                  label={params?.row?.status}
                  icon={<Dot width={"0.5rem"} height={"0.5rem"} />}
                  style={{ color: "#B42318", backgroundColor: "#FEF3F2" }}
                ></LeadStatusChip>
              )}
            </div>
          </div>
        );
      },
    },
    {
      field: "area",
      headerName: "Area",
      width: 150,
      renderCell: (params) => {
        return (
          <div style={{ wordBreak: "break-word" }}>
            {params.row?.area ? `${params.row?.area.toFixed(2)} sq.ft` : ""}
          </div>
        );
      },
    },
    {
      field: "unitCost",
      headerName: "Unit Cost",
      width: 170,
      renderCell: (params) => {
        return (
          <div style={{ wordBreak: "break-word" }}>{params.row?.unitCost}</div>
        );
      },
    },
  ];

  function numDifferentiation(val) {
    if (val >= 10000000) val = (val / 10000000).toFixed(2) + " Cr";
    else if (val >= 100000) val = (val / 100000).toFixed(2) + " Lac";
    else if (val >= 1000) val = (val / 1000).toFixed(2) + " K";
    return val;
  }
  function UsersFromServer(
    pageNumber,
    merge,
    userIds,
    projectId,
    leadId,
    selectDates
  ) {
    presentLoader();
    FetchIndividualUserFromServer(
      pageNumber * pageSize,
      pageNumber * pageSize + pageSize - 1,
      userIds,
      projectId,
      selectDates,
      leadId
    )
      .then((UsersResp) => {
        const dataLeadNotNull = UsersResp?.data?.filter(
          (v) =>
            v?.leadId !== null &&
            v?.leadId?.personId !== null &&
            v?.unitId !== null &&
            v?.unitId?.projectId !== null
        );
        
        const payloadResponse = dataLeadNotNull?.map((v) => {
          return {
            ...v,
            leadName: v?.leadId?.personId?.name,
            id: _.uniqueId("prefix-"),
            leadDisplayID: v?.leadId?.leadDisplayId,
            project: v?.unitId?.projectId?.projectId,
            projectName: v?.unitId?.projectId?.projectName,
            wingName: v?.unitId?.wingId?.wingName,
            unitNo: v?.unitId?.unitNo,
            siteVisit: v?.leadId?.SiteVisits?.filter(s => s?.projectId?.projectId === v?.unitId?.projectId?.projectId),
            status: v?.status,
            area: v?.unitId?.chargeableArea,
            unitCost: numDifferentiation(
              v?.unitCost?.total ? v?.unitCost?.total : 0
            ),
          };
        });

        if (merge) {
          setAllotmentRows((pre) => pre, payloadResponse);
        } else {
          setAllotmentRows(payloadResponse);
        }
        dismissLoader();
      })
      .catch((err) => {
        console.error("FetchAllUserFromServer", err);
        dismissLoader();
      });
  }

  function pageChanged(e) {
    if (pageNumber < e) {
      setPageNumber(e);
    }
  }

  const handleStartDateChange = async (value) => {
    setSelectDates((pre) => {
      pre[0].value = value === "" ? "" : value?.getTime();
      return { ...pre };
    });
    setHelperText((pre) => {
      pre.endDate = "";
      return { ...pre };
    });
    navigate(
      window.location.pathname +
        `?projectName=${selectedProject
          .map((m) => {
            return m.name;
          })
          .toString()}?startDate=${
          value === "" ? 0 : value?.getTime()
        }?endDate=${
          selectDates[1]?.value !== "" ? selectDates[1]?.value : 0
        }?leadName=${
          drpDownSelectedVal?.label ? drpDownSelectedVal?.label : "All"
        }`
    );

    if (
      selectDates[0]?.value !== "" &&
      selectDates[1]?.value !== "" &&
      selectDates[0]?.value !== 0 &&
      selectDates[1]?.value !== 0
    ) {
      UsersFromServer(
        0,
        false,
        individualUserId,
        selectedProject.map((m) => {
          return m.id;
        }),
        drpDownSelectedVal?.value,
        [
          {
            label: "StartDate",
            value: value === "" ? 0 : value?.getTime(),
          },
          {
            label: "EndDate",
            value: selectDates[1]?.value,
          },
        ]
      );
    }
  };

  const handleEndDateChange = async (value) => {
    if (selectDates[0].value === "") {
      setHelperText((pre) => {
        pre.endDate = "Please select start date first";
        return { ...pre };
      });
    } else {
      if (selectDates[0].value > value) {
        setHelperText((pre) => {
          pre.endDate = "Select End Date Greater than start Date";
          return { ...pre };
        });
        setSelectDates((pre) => {
          pre[1].value = "";
          return { ...pre };
        });
      } else {
        setSelectDates((pre) => {
          pre[1].value = value === "" ? "" : value?.getTime();
          return { ...pre };
        });

        setHelperText((pre) => {
          pre.endDate = "";
          return { ...pre };
        });

        navigate(
          window.location.pathname +
            `?projectName=${selectedProject
              .map((m) => {
                return m.name;
              })
              .toString()}?startDate=${
              selectDates[0]?.value !== "" ? selectDates[0]?.value : 0
            }?endDate=${value === "" ? 0 : value?.getTime()}?leadName=${
              drpDownSelectedVal?.label ? drpDownSelectedVal?.label : "All"
            }`
        );

        if (
          selectDates[0]?.value !== "" &&
          selectDates[1]?.value !== "" &&
          selectDates[0]?.value !== 0 &&
          selectDates[1]?.value !== 0
        ) {
          UsersFromServer(
            0,
            false,
            individualUserId,
            selectedProject.map((m) => {
              return m.id;
            }),
            drpDownSelectedVal?.value,
            [
              {
                label: "StartDate",
                value: selectDates[0]?.value,
              },
              {
                label: "EndDate",
                value: value === "" ? 0 : value?.getTime(),
              },
            ]
          );
        }
      }
    }
  };

  return (
    <>
      <Box className={cssClasses.Container}>
        <Box mb={1}>
          <Box className={cssClasses.SubContainer}>
            <Box className={cssClasses.DivContainer}>
              <Box className={cssClasses.HeaderTitle}>Allotment</Box>
            </Box>
          </Box>
        </Box>

        <Divider />

        <Box>
          <Box
            margin={"1rem 0"}
            display={"flex"}
            alignItems={"baseline"}
            justifyContent={"space-between"}
          >
            <Box className={cssClasses.SubContainer}>
              <Box width={"25rem"}>
                <div className={cssClasses.SubTitle}>Select Leads:</div>
                <CustomAutoComplete
                  value={drpDownSelectedVal}
                  NoOptionsText={"No Leads were found"}
                  InitialValue={setDrpDownSelectedVal}
                  OnInputChange={async (e, _value) => {
                    setDrpDownSelectedVal(_value);
                    const name_val = leadsList.find((f) => f.name === _value);
                    if (name_val !== undefined || _value === "All") {
                      UsersFromServer(
                        0,
                        false,
                        individualUserId,
                        selectedProject.map((m) => {
                          return m.id;
                        }),
                        _value === "All" || name_val === undefined
                          ? null
                          : name_val?.id,
                        selectDates
                      );
                      navigate(
                        window.location.pathname +
                          `?projectName=${selectedProject
                            .map((m) => {
                              return m.name;
                            })
                            .toString()}?startDate=${
                            selectDates[1]?.value !== ""
                              ? selectDates[1]?.value
                              : 0
                          }?endDate=${
                            selectDates[1]?.value !== ""
                              ? selectDates[1]?.value
                              : 0
                          }?leadName=${_value}`
                      );
                    }
                  }}
                  list={
                    leadsList
                      ? [
                          { label: "All", value: "All" },
                          ...leadsList?.map((m) => ({
                            label: m?.name,
                            value: m?.id,
                          })),
                        ]
                      : []
                  }
                  disable={false}
                  placeholder="Select Leads"
                />
              </Box>
              <Box>
                <div
                  className={cssClasses.SubTitle}
                  style={{ marginBottom: "0.9rem" }}
                >
                  Select Project:
                </div>
                <MultiSelectDropDown
                  list={projectList}
                  value={selectedProject}
                  handleChange={(e) => {
                    const value = e?.target?.value;
                    if (value !== "") {
                      if (value[value.length - 1] === "all") {
                        setSelectedProject(
                          selectedProject.length === projectList.length
                            ? []
                            : projectList
                        );
                        UsersFromServer(
                          0,
                          false,
                          individualUserId,
                          [],
                          drpDownSelectedVal?.value,
                          selectDates
                        );
                        navigate(
                          window.location.pathname +
                            `?projectName=${(projectList)
                              .map((m) => {
                                return m.name;
                              })
                              .toString()}?startDate=${
                              selectDates[1]?.value !== ""
                                ? selectDates[1]?.value
                                : 0
                            }?endDate=${
                              selectDates[1]?.value !== ""
                                ? selectDates[1]?.value
                                : 0
                            }?leadName=${
                              drpDownSelectedVal?.label
                                ? drpDownSelectedVal?.label
                                : "All"
                            }`
                        );
                        return;
                      }
                      setSelectedProject(value);
                      UsersFromServer(
                        0,
                        false,
                        individualUserId,
                        value.map((m) => {
                          return m.id;
                        }),
                        drpDownSelectedVal?.value,
                        selectDates
                      );
                      navigate(
                        window.location.pathname +
                          `?projectName=${(value)
                            .map((m) => {
                              return m.name;
                            })
                            .toString()}?startDate=${
                            selectDates[1]?.value !== ""
                              ? selectDates[1]?.value
                              : 0
                          }?endDate=${
                            selectDates[1]?.value !== ""
                              ? selectDates[1]?.value
                              : 0
                          }?leadName=${
                            drpDownSelectedVal?.label
                              ? drpDownSelectedVal?.label
                              : "All"
                          }`
                      );
                    }
                  }}
                  placeHolder={"Select Project"}
                  flag={true}
                />
              </Box>
            </Box>
            <div style={{ display: "flex", gap: "2rem" }}>
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  gap: "1rem",
                }}
              >
                <label style={{ fontSize: "1.6rem" }}>Start date:</label>
                <DateComponent
                  value={selectDates[0].value === 0 ? "" : selectDates[0].value}
                  minDate={new Date("01/01/2023")}
                  maxDate={
                    selectDates[1]?.value !== "" && selectDates[1]?.value !== 0
                      ? new Date(selectDates[1]?.value)
                      : new Date()
                  }
                  onChangeDate={(value) => {
                    handleStartDateChange(value);
                  }}
                  helperText={helperText.startDate}
                ></DateComponent>
              </div>
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  gap: "1rem",
                }}
              >
                <label style={{ fontSize: "1.6rem" }}>End date:</label>
                <DateComponent
                  value={selectDates[1].value === 0 ? "" : selectDates[1].value}
                  isClassName
                  minDate={new Date(selectDates[0]?.value)}
                  maxDate={new Date()}
                  onChangeDate={(value) => {
                    handleEndDateChange(value);
                  }}
                  helperText={helperText.endDate}
                ></DateComponent>
              </div>
            </div>
          </Box>
        </Box>
        {AllotmentRows?.length > 0 && (
          <Box className={cssClasses.GridWrapper} id="Allotment-data-grid">
            <Datagrid
              pageChanged={pageChanged}
              hideFooter={false}
              columns={SoldDetailsColumns}
              rows={AllotmentRows}
              rowsPerPageOptions={[11]}
              CancellationsAndRefunds={11}
            />
          </Box>
        )}
        {AllotmentRows?.length === 0 && (
          <Box sx={{ height: "100%" }}>
            <Box className={cssClasses.noDataMsg}>
              <Box className={cssClasses.emptyIcon}>
                <img src={EmptyState} alt="No Wings" />
              </Box>
              <Box className={cssClasses.emptyTitle}>No Allotment found</Box>
            </Box>
          </Box>
        )}
      </Box>
      {showSiteVisitModal && (
        <SiteVisitDetailModal
          open={showSiteVisitModal}
          selectedSiteVisits={selectedSiteVisit}
          handleClose={() => {
            setShowSiteVisitModal(false);
          }}
        />
      )}
    </>
  );
}

export default IndividualAllotmentDetails;
